<p-toast position="bottom-center"></p-toast>
<p-confirmDialog [style]="{width: '450px'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>

<div class="page-title" style="display: flex; align-items: center; justify-content: space-between;">
  <div>
    <h3 style="padding-top: 1rem; padding-bottom: 1rem;">
      Deploy Management
    </h3>
  </div>
  <div style="display: flex; gap: 1rem; align-items: center;">
    <button pButton type="button" class="refresh-button" (click)="refreshDeploymentProgress()" [disabled]="refreshLoading" [icon]="refreshLoading ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'">
      Refresh
    </button>
  </div>
</div>

<!-- Tab switcher -->
<div class="tab-switcher" style="display: flex; gap: 0; margin-bottom: 1rem;">
  <button
    type="button"
    class="tab-button"
    [class.active]="activeTab === 'traditional'"
    (click)="selectTab('traditional')"
    style="padding: 0.5rem 1.5rem; border: 1px solid #dc582e; border-right: none; border-radius: 4px 0 0 4px; cursor: pointer; font-weight: 600; font-size: 0.9rem; transition: background 0.15s, color 0.15s;"
    [style.background]="activeTab === 'traditional' ? '#dc582e' : '#ffffff'"
    [style.color]="activeTab === 'traditional' ? '#ffffff' : '#dc582e'"
  >
    Traditional
  </button>
  <button
    type="button"
    class="tab-button"
    [class.active]="activeTab === 'mender'"
    (click)="selectTab('mender')"
    style="padding: 0.5rem 1.5rem; border: 1px solid #dc582e; border-radius: 0 4px 4px 0; cursor: pointer; font-weight: 600; font-size: 0.9rem; transition: background 0.15s, color 0.15s;"
    [style.background]="activeTab === 'mender' ? '#dc582e' : '#ffffff'"
    [style.color]="activeTab === 'mender' ? '#ffffff' : '#dc582e'"
  >
    Fully Automatic
  </button>
</div>

<!-- Traditional tab -->
<p-card *ngIf="activeTab === 'traditional'">
  <app-besharp-table
    [tableItems]="traditionalDatasource"
    [totalRecords]="traditionalTotal"
    [lazyMode]="true"
    [loading]="traditionalLoading"
    [debounceSearchTime]="300"
    [idColumnDef]="'id'"
    [tableDefinitions]="traditionalTableDefinition"
    [actionDefinitions]="actionDefinition"
    [globalFilterFields]="globalFilterFieldsTraditional"
    [actionTitle]="''"
    [tableSize]="eBesharpTableSize.Small"
    [defaultActive]="'id'"
    [defaultDirection]="-1"
    [paginator]="true"
    [pageRows]="traditionalPageRows"
    [pageRowsOptions]="[5, 10, 20]"
    [showCurrentPageReport]="true"
    [showSearchInput]="true"
    [showClearFiltersButton]="true"
    [showExportButton]="true"
    [showStripes]="true"
    [showGridLines]="false"
    [rowOverEffect]="true"
    (onPageChange)="onTraditionalPageChange($event)"
    (onSortChange)="onTraditionalSortChange($event)"
    (onClearFilters)="clearTraditionalFilters()"
    (onColumnFilter)="onTraditionalColumnFilter($event)"
    (onGlobalSearch)="onTraditionalGlobalSearch($event)"
  />
</p-card>

<!-- Mender tab -->
<p-card *ngIf="activeTab === 'mender'">
  <app-besharp-table
    [tableItems]="menderDatasource"
    [totalRecords]="menderTotal"
    [lazyMode]="true"
    [loading]="menderLoading"
    [debounceSearchTime]="300"
    [idColumnDef]="'id'"
    [tableDefinitions]="menderTableDefinition"
    [actionDefinitions]="actionDefinition"
    [globalFilterFields]="globalFilterFieldsMender"
    [actionTitle]="''"
    [tableSize]="eBesharpTableSize.Small"
    [defaultActive]="'id'"
    [defaultDirection]="-1"
    [paginator]="true"
    [pageRows]="menderPageRows"
    [pageRowsOptions]="[5, 10, 20]"
    [showCurrentPageReport]="true"
    [showSearchInput]="true"
    [showClearFiltersButton]="true"
    [showExportButton]="true"
    [showStripes]="true"
    [showGridLines]="false"
    [rowOverEffect]="true"
    (onPageChange)="onMenderPageChange($event)"
    (onSortChange)="onMenderSortChange($event)"
    (onClearFilters)="clearMenderFilters()"
    (onColumnFilter)="onMenderColumnFilter($event)"
    (onGlobalSearch)="onMenderGlobalSearch($event)"
  />
</p-card>

<!-- Deployment Details Modal -->
<p-dialog
  header="Deployment Details"
  [(visible)]="showDetailsModal"
  [modal]="true"
  [closable]="!loadingDetails"
  [style]="{width: '700px'}"
  [draggable]="false"
  [resizable]="false"
>
  <div class="details-modal-content">

    <!-- Loading spinner -->
    <div *ngIf="loadingDetails" class="loading-container" style="text-align: center; padding: 2rem;">
      <p-progressSpinner [style]="{'width': '50px', 'height': '50px'}" strokeWidth="4" />
      <p style="margin-top: 1rem;">Loading deployment details...</p>
    </div>

    <div *ngIf="!loadingDetails && deploymentDetails" class="details-content">

      <!-- ── MENDER DETAILS ─────────────────────────────────────────────── -->
      <ng-container *ngIf="deploymentDetails.isMender">

        <div class="detail-section" style="margin-bottom: 1.5rem;">
          <h4 style="margin-bottom: 1rem; color: var(--primary-color);">General Information</h4>
          <div class="detail-grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
            <div class="detail-item">
              <label><strong>Portal Status:</strong></label>
              <p [innerHTML]="getStatusBadge(deploymentDetails.status)"></p>
            </div>
            <div class="detail-item">
              <label><strong>Deployment Date:</strong></label>
              <p>{{formatDate(deploymentDetails.deploymentDate)}}</p>
            </div>
            <div class="detail-item" *ngIf="deploymentDetails.liveDetails?.status">
              <label><strong>Mender Status:</strong></label>
              <p style="font-family: monospace; text-transform: capitalize;">{{deploymentDetails.liveDetails.status}}</p>
            </div>
            <div class="detail-item" *ngIf="deploymentDetails.liveDetails?.name">
              <label><strong>Mender Deployment Name:</strong></label>
              <p style="font-family: monospace; word-break: break-all;">{{deploymentDetails.liveDetails.name}}</p>
            </div>
            <div class="detail-item" *ngIf="deploymentDetails.liveDetails?.created">
              <label><strong>Created in Mender:</strong></label>
              <p>{{formatDate(deploymentDetails.liveDetails.created)}}</p>
            </div>
            <div class="detail-item" *ngIf="deploymentDetails.liveDetails?.finished">
              <label><strong>Finished in Mender:</strong></label>
              <p>{{formatDate(deploymentDetails.liveDetails.finished)}}</p>
            </div>
            <div class="detail-item" *ngIf="deploymentDetails.liveDetails?.device_count != null">
              <label><strong>Device Count:</strong></label>
              <p>{{deploymentDetails.liveDetails.device_count}}</p>
            </div>
            <div class="detail-item" *ngIf="deploymentDetails.liveDetails?.type">
              <label><strong>Deployment Type:</strong></label>
              <p style="text-transform: capitalize;">{{deploymentDetails.liveDetails.type}}</p>
            </div>
          </div>
        </div>

        <!-- Statistics from Mender -->
        <ng-container *ngIf="deploymentDetails.liveDetails?.statistics">
          <hr style="border: none; border-top: 1px solid #ddd; margin: 1.5rem 0;">
          <div class="detail-section" style="margin-bottom: 1.5rem;">
            <h4 style="margin-bottom: 1rem; color: var(--primary-color);">Deployment Statistics</h4>
            <div class="detail-grid" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem;">
              <div class="detail-item" style="background: var(--green-50); padding: 0.75rem; border-radius: 6px; text-align: center;">
                <label style="display: block; font-size: 0.75rem; color: #666;">Success</label>
                <p style="font-size: 1.5rem; font-weight: 700; color: var(--green-600); margin: 0;">
                  {{deploymentDetails.liveDetails.statistics.success ?? 0}}
                </p>
              </div>
              <div class="detail-item" style="background: var(--blue-50); padding: 0.75rem; border-radius: 6px; text-align: center;">
                <label style="display: block; font-size: 0.75rem; color: #666;">Already Installed</label>
                <p style="font-size: 1.5rem; font-weight: 700; color: var(--blue-600); margin: 0;">
                  {{deploymentDetails.liveDetails.statistics.already_installed ?? 0}}
                </p>
              </div>
              <div class="detail-item" style="background: var(--red-50); padding: 0.75rem; border-radius: 6px; text-align: center;">
                <label style="display: block; font-size: 0.75rem; color: #666;">Failure</label>
                <p style="font-size: 1.5rem; font-weight: 700; color: var(--red-600); margin: 0;">
                  {{deploymentDetails.liveDetails.statistics.failure ?? 0}}
                </p>
              </div>
              <div class="detail-item" style="background: var(--orange-50); padding: 0.75rem; border-radius: 6px; text-align: center;">
                <label style="display: block; font-size: 0.75rem; color: #666;">Aborted</label>
                <p style="font-size: 1.5rem; font-weight: 700; color: var(--orange-600); margin: 0;">
                  {{deploymentDetails.liveDetails.statistics.aborted ?? 0}}
                </p>
              </div>
              <div class="detail-item" style="background: var(--surface-ground); padding: 0.75rem; border-radius: 6px; text-align: center;">
                <label style="display: block; font-size: 0.75rem; color: #666;">No Artifact</label>
                <p style="font-size: 1.5rem; font-weight: 700; margin: 0;">
                  {{deploymentDetails.liveDetails.statistics.noartifact ?? 0}}
                </p>
              </div>
              <div class="detail-item" style="background: var(--surface-ground); padding: 0.75rem; border-radius: 6px; text-align: center;">
                <label style="display: block; font-size: 0.75rem; color: #666;">In Progress</label>
                <p style="font-size: 1.5rem; font-weight: 700; margin: 0;">
                  {{deploymentDetails.liveDetails.statistics.downloading ?? 0}}
                </p>
              </div>
            </div>
          </div>
        </ng-container>

        <hr style="border: none; border-top: 1px solid #ddd; margin: 1.5rem 0;">

        <div class="detail-section" style="margin-bottom: 1.5rem;">
          <h4 style="margin-bottom: 1rem; color: var(--primary-color);">Machine Information</h4>
          <div class="detail-grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
            <div class="detail-item">
              <label><strong>Serial Number:</strong></label>
              <p style="font-weight: 600; color: var(--primary-color);">{{deploymentDetails.serialNumber}}</p>
            </div>
            <div class="detail-item">
              <label><strong>Family:</strong></label>
              <p>{{deploymentDetails.family}}</p>
            </div>
            <div class="detail-item" *ngIf="deploymentDetails.menderSerial">
              <label><strong>Mender Serial:</strong></label>
              <p style="font-family: monospace;">{{deploymentDetails.menderSerial}}</p>
            </div>
          </div>
        </div>

        <hr style="border: none; border-top: 1px solid #ddd; margin: 1.5rem 0;">

        <div class="detail-section" style="margin-bottom: 1.5rem;">
          <h4 style="margin-bottom: 1rem; color: var(--primary-color);">Mender Artifact</h4>
          <div class="detail-grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
            <div class="detail-item" style="grid-column: 1 / -1;">
              <label><strong>Artifact Name:</strong></label>
              <p style="font-weight: 600; color: var(--blue-600); word-break: break-all;">{{deploymentDetails.artifactName}}</p>
            </div>
            <div class="detail-item" *ngIf="deploymentDetails.artifactDeviceType">
              <label><strong>Device Type:</strong></label>
              <p style="font-family: monospace;">{{deploymentDetails.artifactDeviceType}}</p>
            </div>
            <div class="detail-item" style="grid-column: 1 / -1;">
              <label><strong>Mender Deployment ID:</strong></label>
              <p style="font-family: monospace; font-size: 0.85rem; color: #666; word-break: break-all;">{{deploymentDetails.menderDeploymentId}}</p>
            </div>
          </div>
        </div>

        <!-- Per-device list from Mender -->
        <ng-container *ngIf="deploymentDetails.liveDetails?.device_list?.length > 0">
          <hr style="border: none; border-top: 1px solid #ddd; margin: 1.5rem 0;">
          <div class="detail-section" style="margin-bottom: 1.5rem;">
            <h4 style="margin-bottom: 1rem; color: var(--primary-color);">Device Status</h4>
            <table style="width: 100%; border-collapse: collapse; font-size: 0.875rem;">
              <thead>
                <tr style="background: var(--surface-ground);">
                  <th style="text-align: left; padding: 0.5rem 0.75rem; border-bottom: 1px solid #ddd;">Device ID</th>
                  <th style="text-align: left; padding: 0.5rem 0.75rem; border-bottom: 1px solid #ddd;">Status</th>
                  <th style="text-align: left; padding: 0.5rem 0.75rem; border-bottom: 1px solid #ddd;">Artifact</th>
                  <th style="text-align: left; padding: 0.5rem 0.75rem; border-bottom: 1px solid #ddd;">Finished</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let device of deploymentDetails.liveDetails.device_list" style="border-bottom: 1px solid #f0f0f0;">
                  <td style="padding: 0.5rem 0.75rem; font-family: monospace; font-size: 0.8rem; color: #666; word-break: break-all;">{{device.id}}</td>
                  <td style="padding: 0.5rem 0.75rem;">
                    <span [style.color]="device.status === 'success' ? 'var(--green-600)' :
                                         device.status === 'already-installed' ? 'var(--blue-600)' :
                                         device.status === 'failure' || device.status === 'aborted' ? 'var(--red-600)' :
                                         'var(--orange-600)'">
                      {{device.status}}
                    </span>
                  </td>
                  <td style="padding: 0.5rem 0.75rem; font-family: monospace; font-size: 0.8rem;">
                    {{device.image?.name || device.artifact_name || '-'}}
                  </td>
                  <td style="padding: 0.5rem 0.75rem; font-size: 0.8rem; color: #666;">
                    {{device.finished ? formatDate(device.finished) : '-'}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

        <ng-container *ngIf="deploymentDetails.deploymentNotes">
          <hr style="border: none; border-top: 1px solid #ddd; margin: 1.5rem 0;">
          <div class="detail-section">
            <h4 style="margin-bottom: 1rem; color: var(--primary-color);">Deployment Notes</h4>
            <div class="notes-content" style="background: var(--surface-ground); padding: 1rem; border-radius: 6px; border-left: 4px solid var(--blue-500);">
              <p style="margin: 0; white-space: pre-wrap;">{{deploymentDetails.deploymentNotes}}</p>
            </div>
          </div>
        </ng-container>

      </ng-container>
      <!-- ── END MENDER DETAILS ─────────────────────────────────────────── -->

      <!-- ── TRADITIONAL DETAILS ───────────────────────────────────────── -->
      <ng-container *ngIf="!deploymentDetails.isMender">

        <div class="detail-section" style="margin-bottom: 1.5rem;">
          <h4 style="margin-bottom: 1rem; color: var(--primary-color);">General Information</h4>
          <div class="detail-grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
            <div class="detail-item">
              <label><strong>Status:</strong></label>
              <p [innerHTML]="getStatusBadge(deploymentDetails.status)"></p>
            </div>
            <div class="detail-item">
              <label><strong>Deployment Date:</strong></label>
              <p>{{formatDate(deploymentDetails.deploymentDate)}}</p>
            </div>
            <div class="detail-item">
              <label><strong>User Email:</strong></label>
              <p>{{deploymentDetails.userEmail}}</p>
            </div>
          </div>
        </div>

        <hr style="border: none; border-top: 1px solid #ddd; margin: 1.5rem 0;">

        <div class="detail-section" style="margin-bottom: 1.5rem;">
          <h4 style="margin-bottom: 1rem; color: var(--primary-color);">Machine Information</h4>
          <div class="detail-grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
            <div class="detail-item">
              <label><strong>Serial Number:</strong></label>
              <p style="font-weight: 600; color: var(--primary-color);">{{deploymentDetails.serialNumber}}</p>
            </div>
            <div class="detail-item">
              <label><strong>Model:</strong></label>
              <p>{{deploymentDetails.model}}</p>
            </div>
            <div class="detail-item">
              <label><strong>Family:</strong></label>
              <p>{{deploymentDetails.family}}</p>
            </div>
            <div class="detail-item">
              <label><strong>Model Version:</strong></label>
              <p>{{deploymentDetails.modelVersion}}</p>
            </div>
          </div>
        </div>

        <hr style="border: none; border-top: 1px solid #ddd; margin: 1.5rem 0;">

        <div class="detail-section" style="margin-bottom: 1.5rem;">
          <h4 style="margin-bottom: 1rem; color: var(--primary-color);">Software Version Details</h4>
          <div class="detail-grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
            <div class="detail-item">
              <label><strong>Version Number:</strong></label>
              <p style="font-weight: 600; color: var(--blue-600);">{{deploymentDetails.softwareVersionNumber}}</p>
            </div>
            <div class="detail-item">
              <label><strong>Environment:</strong></label>
              <p>{{deploymentDetails.softwareVersionEnvironment?.toUpperCase()}}</p>
            </div>
            <div class="detail-item">
              <label><strong>Release Date:</strong></label>
              <p>{{formatDate(deploymentDetails.softwareVersionReleaseDate)}}</p>
            </div>
          </div>
          <div class="detail-item" style="margin-top: 1rem;" *ngIf="deploymentDetails.softwareVersionDescription">
            <label><strong>Software Description:</strong></label>
            <div class="description-content" style="background: var(--blue-50); padding: 0.75rem; border-radius: 6px; border-left: 4px solid var(--blue-500);">
              <p style="margin: 0;">{{deploymentDetails.softwareVersionDescription}}</p>
            </div>
          </div>
        </div>

        <hr style="border: none; border-top: 1px solid #ddd; margin: 1.5rem 0;">

        <div class="detail-section" style="margin-bottom: 1.5rem;">
          <h4 style="margin-bottom: 1rem; color: var(--primary-color);">Model Software Information</h4>
          <div class="detail-grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
            <div class="detail-item">
              <label><strong>Model Release Date:</strong></label>
              <p>{{formatDate(deploymentDetails.modelReleaseDate)}}</p>
            </div>
            <div class="detail-item">
              <label><strong>Model Environment:</strong></label>
              <p>{{deploymentDetails.modelSoftwareEnvironment?.toUpperCase()}}</p>
            </div>
          </div>
          <div class="detail-item" style="margin-top: 1rem;" *ngIf="deploymentDetails.modelSoftwareDescription">
            <label><strong>Model Software Description:</strong></label>
            <div class="description-content" style="background: var(--green-50); padding: 0.75rem; border-radius: 6px; border-left: 4px solid var(--green-500);">
              <p style="margin: 0;">{{deploymentDetails.modelSoftwareDescription}}</p>
            </div>
          </div>
        </div>

        <ng-container *ngIf="deploymentDetails.notes">
          <hr style="border: none; border-top: 1px solid #ddd; margin: 1.5rem 0;">
          <div class="detail-section">
            <h4 style="margin-bottom: 1rem; color: var(--primary-color);">System Notes</h4>
            <div class="notes-content" style="background: var(--surface-ground); padding: 1rem; border-radius: 6px; border-left: 4px solid var(--primary-color);">
              <p style="margin: 0; white-space: pre-wrap;">{{deploymentDetails.notes}}</p>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="deploymentDetails.deploymentNotes">
          <hr style="border: none; border-top: 1px solid #ddd; margin: 1.5rem 0;">
          <div class="detail-section">
            <h4 style="margin-bottom: 1rem; color: var(--primary-color);">Deployment Notes</h4>
            <div class="notes-content" style="background: var(--surface-ground); padding: 1rem; border-radius: 6px; border-left: 4px solid var(--blue-500);">
              <p style="margin: 0; white-space: pre-wrap;">{{deploymentDetails.deploymentNotes}}</p>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="deploymentProgress">
          <hr style="border: none; border-top: 1px solid #ddd; margin: 1.5rem 0;">
          <div class="detail-section">
            <h4 style="margin-bottom: 1rem; color: var(--primary-color);">Deployment Progress</h4>
            <div class="progress-content" style="background: var(--blue-50); padding: 1rem; border-radius: 6px; border-left: 4px solid var(--blue-500);">
              <div class="progress-summary" style="margin-bottom: 1rem;">
                <div class="detail-grid" style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 1rem;">
                  <div class="progress-stat">
                    <label><strong>Progress:</strong></label>
                    <p>{{deploymentProgress.completionPercentage}}%</p>
                  </div>
                  <div class="progress-stat">
                    <label><strong>Files Deployed:</strong></label>
                    <p>{{deploymentProgress.deployedFiles}}/{{deploymentProgress.totalFiles}}</p>
                  </div>
                  <div class="progress-stat">
                    <label><strong>Failed Files:</strong></label>
                    <p style="color: var(--red-600);" *ngIf="deploymentProgress.failedFiles > 0">{{deploymentProgress.failedFiles}}</p>
                    <p *ngIf="deploymentProgress.failedFiles === 0">0</p>
                  </div>
                </div>
              </div>
              <div class="progress-bar-container" style="margin-bottom: 1rem;">
                <p-progressBar
                  [value]="deploymentProgress.completionPercentage"
                  [style]="{'height': '10px'}"
                  [showValue]="false">
                </p-progressBar>
              </div>
              <div class="machine-statuses" *ngIf="deploymentProgress.machineStatuses?.length > 0">
                <label><strong>Machine Status:</strong></label>
                <div class="machine-list" style="margin-top: 0.5rem;">
                  <div *ngFor="let machine of deploymentProgress.machineStatuses"
                       class="machine-status"
                       style="display: flex; justify-content: space-between; align-items: center; padding: 0.5rem; background: white; border-radius: 4px; margin-bottom: 0.5rem; border: 1px solid #e0e0e0;">
                    <span style="font-weight: 500;">{{machine.machineName || machine.machineId}}</span>
                    <div style="display: flex; align-items: center; gap: 1rem;">
                      <span class="badge" [ngClass]="'badge-' + (machine.status === 'completed' ? 'success' : machine.status === 'failed' ? 'danger' : 'warning')">
                        {{machine.status}}
                      </span>
                      <span style="font-size: 0.875rem; color: #666;">{{machine.deployedFiles}}/{{machine.totalFiles}} files</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

      </ng-container>
      <!-- ── END TRADITIONAL DETAILS ───────────────────────────────────── -->

    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="details-modal-footer">
      <p-button
        label="Close"
        icon="pi pi-times"
        (onClick)="closeDetailsModal()"
        [disabled]="loadingDetails"
      />
    </div>
  </ng-template>
</p-dialog>
